<!-- src\app\components\order\fulle-endorder\fulle-endorder.component.html -->
<div class="h-full flex flex-col patternBG">

  <!-- Header order -->
  <app-header-order [redirectPage]="'endorder'" class="w-full"
    (devicechangeEvent)="devicechange($event)"></app-header-order>

  <!-- Main comp -->
  <div class="flex-1 flex flex-col items-center scrolled" *ngIf="currPOS">

    <!-- Comp 959px (lt-md) -->
    <div style="width: 959px;" class="px-4 pb-4" ngClass.lt-md="full-w" fxFlex.lt-md>

      <!-- Logo and point of sale info -->
      <div class="flex flex-row items-center gap-4 mb-4 p-4" [ngClass]="cssService.cardClass">

        <!-- Logo -->
        <img [ngClass]="cssService.posImageClass" class="hidden sm:block" src="{{ currPOS.img }}"
          *ngIf="currPOS.img" />

        <!-- Infos pointofsale -->
        <div class="flex flex-col gap-2.5">

          <!-- Point de vente -->
          <div class="mb-4">
            <span class="text-lg sm:text-2xl text-gray-800 uppercase font-bold fontPoppins">{{ currPOS.denomination
              }}</span>
          </div>

          <!-- Coordonnées-->
          <div class="flex flex-col">

            <!-- Adresse-->
            <div class="flex justify-start items-center mb-1 text-sm" class="text-sm text-gray-800 font-semibold">
              <i class="material-icons text-indigo-500 mr-2">location_on</i>
              <div>
                <span>{{ currPOS.address | uppercase }} -
                  {{ currPOS.postal }}
                  {{ currPOS.city | uppercase }}</span>
              </div>
            </div>

            <!-- Téléphone-->
            <div class="flex flex-row justify-start items-center mb-2 text-sm"
              class="text-sm text-gray-800 font-semibold">
              <i class="material-icons text-indigo-500 mr-2">phone</i>
              <!-- <span *ngIf="currPOS.phone_2">{{ currPOS.phone_2 }}&nbsp;&nbsp;</span> -->
              <span *ngIf="currPOS.phone">{{ currPOS.phone }}</span>
            </div>
          </div>

          <!-- Bouton Horaires-->
          <app-fulle-thumbnail-shedules class="mt-2" *ngIf="currSM.enable_date_hour" [sale_method]="currSM"
            [point_of_sale]="currPOS" [isBlock]="true">
          </app-fulle-thumbnail-shedules>
        </div>
      </div>

      <!-- Info order -->
      <div *ngIf="currSM.description_order" style="margin-bottom: 20px;">
        <app-order-info-thumbnail></app-order-info-thumbnail>
      </div>

      <!-- Data|Hour order -->
      <div *ngIf="currSM.enable_date_hour" style="margin-bottom: 20px;">
        <app-date-order [error]="error" (clearErrorEvent)="clearErrors($event) "></app-date-order>
      </div>

      <!-- Delivry addresses && Shipping modes -->
      <div fxLayout="column" fxLayoutGap="10px"
        *ngIf="(currSM.enable_delivery> 0 || currSM.enable_shipping_cost > 0)&& !currSM.disable_authentification"
        style="margin-bottom: 20px;">
        <app-addresses-endorder [clientAddresses$]="clientAddresses$" [type]="'delivry'" [error]="error"
          (setIsRelayEvent)="setIsRelay($event)" (setSelectedRelayEvent)="setSelectedRelay($event)">
        </app-addresses-endorder>
      </div>

      <!-- Billing addresses -->
      <div fxLayout="column" fxLayoutGap="10px" id="billingaddress" style="margin-bottom: 20px;"
        *ngIf="currSM.enable_billing_address">
        <app-addresses-endorder [clientAddresses$]="clientAddresses$" [type]="'billing'" [error]="error">
        </app-addresses-endorder>
      </div>

      <!-- Infos order -->
      <div *ngIf="infosNote$" style="margin-bottom: 20px;">
        <app-info-order [infosNote$]="infosNote$" [currSM]="currSM" [currPOS]="currPOS"
          [error]="error"></app-info-order>
      </div>

      <!-- credit_fidelity_amount  remise fidelity -->
      <div fxLayout="column" fxLayoutGap="10px" style="margin-bottom: 20px;"
        *ngIf=" allPrice && allPrice - discountClient > 0
                && merchantClient && merchantClient.credit_fidelity_amount> 0
                && (currSM.payment_type !== 'counter') && (currSM.payment_type !== 'secure_counter') && (currSM.enable_device_check !== 1)">
        <div fxLayout="row" fxLayoutGap="10px">
          <span class="title-endorder-card boldest">{{ "endorder.remise" | translate | capitalize }}</span>
        </div>
        <div fxLayout="column" fxLayoutGap="10px" class="clicked " [ngClass]="cssService.sectionCardClass"
          (click)="toggleUseCreditFid()">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">

            <img src="assets/img/refonte-logo/loyal.png" class="h-10">

            <span class="mat-subheading-1">{{"endorder.cagnotte-fid" |
              translate}}</span>
            <div fxFlex></div>
            <mat-checkbox (click)="$event.preventDefault()" color="primary" [checked]="currSM.use_client_credit_fid"
              style="margin-right: 10px;">
            </mat-checkbox>
          </div>
          <div fxLayout="column" fxLayoutGap="5px">
            <!-- nonchecked -->
            <span class="mat-caption"
              *ngIf="!currSM.use_client_credit_fid&&(allPrice-discountClient<merchantClient.credit_fidelity_amount)"
              [innerHTML]="'endorder.use-cagnotte-full-fid-new' | translate:
                 {'credit': (allPrice-discountClient)  |priceFilter ,'totalCagnotte': (merchantClient.credit_fidelity_amount)|priceFilter }"></span>
            <span class="mat-caption"
              *ngIf="!currSM.use_client_credit_fid && allPrice-discountClient>=merchantClient.credit_fidelity_amount"
              [innerHTML]="'endorder.use-cagnotte-part-fid' | translate:
                   {'credit': merchantClient.credit_fidelity_amount |priceFilter}"></span>

            <!-- checked -->
            <span class="mat-caption" *ngIf="currSM.use_client_credit_fid  " [innerHTML]="'endorder.use-cagnotte-full-fidy-used' | translate:
                      {'credit': (fidelityDiscountUsed)  |priceFilter  }"></span>
            <span
              *ngIf="currSM.use_client_credit_fid && !currSM.use_client_credit&& (allPrice-discountClient)> merchantClient.credit_fidelity_amount"
              class="mat-caption">{{"endorder.use-cagnotte-rest-fid" |
              translate}} {{ (allTotal)|priceFilter}}</span>
          </div>
        </div>
      </div>

      <!-- Payment methods (new) -->
      <div fxLayout="column" fxLayoutGap="10px" style="margin-bottom: 20px;">

        <!-- means-of-payment title -->
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <span class="title-endorder-card boldest" *ngIf="showPaymentMethodsTitle ">{{
            "endorder.means-of-payment" | translate | capitalize
            }}</span>
        </div>

        <!--
          Cagnotte client
        -->
        <div fxLayout="column" fxLayoutGap="10px" [ngClass]="cssService.sectionCardClass" class=" clicked"
          (click)="toggleUseCredit()" *ngIf="canUseCagnotte()">


          <!-- Title -->
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <img src="assets/img/refonte-logo/Cagnotte.png" class="h-10">
            <span class="mat-subheading-1">{{"endorder.cagnotte" |
              translate}}</span>
            <div fxFlex></div>
            <mat-checkbox (click)="$event.preventDefault()" color="primary"
              [checked]="currSM.use_client_credit && allTotal>0" [disabled]="disabledCagnotte" style="margin-right:
                10px;"></mat-checkbox>
          </div>
          <div fxLayout="column" fxLayoutGap="5px">
            <span class="mat-caption" *ngIf="merchantClient && allTotal <=
            merchantClient.credit_amount" [innerHTML]="'endorder.use-cagnotte-full-new' | translate:
            {'credit': allTotal |priceFilter ,'totalCagnotte': (merchantClient.credit_amount)|priceFilter }"></span>
            <span class="mat-caption" *ngIf="merchantClient && allTotal> merchantClient.credit_amount" [innerHTML]="'endorder.use-cagnotte-part' | translate:
                          {'credit': merchantClient.credit_amount |priceFilter}"></span>
            <span *ngIf="merchantClient && allTotal> merchantClient.credit_amount" class="mat-caption">
              {{"endorder.use-cagnotte-rest" | translate}} {{allTotal-merchantClient.credit_amount
              |priceFilter}}</span>
          </div>
        </div>
        <div *ngIf="showPaymentMethods">
          <app-fulle-payments-methods-endorder [currPaymentChoice]="currPaymentChoice"
            (openCardMethodsDialEvent)="openCardMethodsDial($event)" (setClientCardsDialEvent)="setClientCards($event)"
            (setPaymentChoiceEvent)="setPaymentChoice_($event)" [currPOS]="currPOS" [currSM]="currSM"
            [deviceChange]="deviceChange" [clientCards]="clientCards$" [currCard$]="currCard$"
            [clientCardLoader]="clientCardLoader"
            [showPaymentMethods]="showPaymentMethods"></app-fulle-payments-methods-endorder>
        </div>

        <!-- Loyalty point (new) -->
        <div fxLayout="column" fxLayoutGap="10px" style="margin-bottom: 20px;">
          <div *ngIf="checFid>0 ">
            <div fxLayout="row" fxLayoutAlign="space-between center " style="padding: 10px 0;">
              <div>
                <span class="title-endorder-card boldest">
                  {{"loyalty_title"|translate| capitalize}} </span>
                <span class="mat-subheading-3 "> ({{FidelityPointClient}} {{"points"|translate}})</span>
              </div>
            </div>
            <div fxLayout="column" fxLayoutAlign="center start" [ngClass]="cssService.sectionCardClass"
              class=" clicked pad10" (click)="checkFidelityPoints()">

              <!-- points  -->
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <div style="width: 50px;height: 30px " fxLayoutAlign="center center">
                  <mat-icon style="color: green;">loyalty</mat-icon>
                </div>
                <span class="mat-subheading-1"
                  [class.boldest]="(merchantClient!.fidelity_points-FidelityPointClient)>0 ">
                  {{merchantClient!.fidelity_points-FidelityPointClient}}
                  {{"loyalty_points"|translate}} {{"used"|translate}}</span>
              </div>

              <!-- text points -->
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <div class="mat-caption " style="color:grey;"
                  *ngIf=" (merchantClient!.fidelity_points-FidelityPointClient)>0">
                  {{"use_fidelity_points"|translate}}
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- EndOrder button  -->
        <app-fulle-basket-endorder [error]="error" [isRelay]="isRelay" [selectedRelay]="selectedRelay" [orderCard]="currCard$"
          [billingAddress]="currBillingAddress$" [delivryAddress]="currDelivryAddress$"
          [currPaymentChoice]="currPaymentChoice" [activeButton]="activePanierButton" [merchantClient]="merchantClient"
          [credit_fid]="currSM.use_client_credit_fid" [activeDeviceandButtonTerms]="activeDeviceandButtonTerms"
          (readErrorsEvent)="readErrors($event)" (setPageLoaderEvent)="setPageIsLoading($event)"
          [errorYetPayed]="errorYetPayed">
        </app-fulle-basket-endorder>
      </div>
    </div>
    <app-popup-loader [flagLoading]="pageIsLoading"
      [statusMessage]="(statusMessage?statusMessage:'endOrderComponent.loaderOrderend') |translate" [size]="30">
    </app-popup-loader>
  </div>
</div>